import React, { Component } from 'react';
import { Row, OverlayTrigger, Tooltip } from 'react-bootstrap';
import PropTypes from 'prop-types';
import cns from 'classnames';
import { get } from 'lodash';
import { RuntimeContext } from '../../../../common/RuntimeContext';
import Image from '../../components/Image';
import { LEARNING_ASSET_DURATIONS, LEARNING_ASSET_TYPE_OBJECT, ASSET_TYPE_ICONS } from '../../Constants';
import { overlayImageIds } from '../../utils/ImageUtils';
import VerbDropdownButton, { VERB_BUTTON_TYPE } from '../../components/VerbDropdownButton';
import { useContext } from 'react';

const completionStatusIcon = {
    DONE: 'fa-check-circle',
    'IN PROGRESS': 'fa-arrow-circle-right',
    'NOT STARTED': 'fa-exclamation-circle',
    LOCKED: 'fa-lock-alt'
};

class CollectionLearningAssetRow extends Component {
    static propTypes = {
        learningAsset: PropTypes.object,
        userLearningAssetsByAssetId: PropTypes.object,
        isLocked: PropTypes.bool,
        handleAssetRowClick: PropTypes.func,
        isReviewCollection: PropTypes.bool,
        isLockedReflection: PropTypes.bool
    };

    static contextType = RuntimeContext

    _getAssetTypeIcon = (currentType) => ASSET_TYPE_ICONS[currentType];

    _getCompleteness = () => {
        const { learningAsset, userLearningAssetsByAssetId, isLocked } = this.props;
        if (isLocked) {
            return 'LOCKED';
        }
        const userLearningAsset = userLearningAssetsByAssetId[learningAsset._id];
        const completeness = get(userLearningAsset, 'completeness', 0);
        if (completeness === 100 || get(userLearningAsset, 'isCompleted', false) === true) {
            return 'DONE';
        }
        if (completeness > 0 && completeness < 100) {
            return 'IN PROGRESS';
        }
        return 'NOT STARTED';
    };

    render() {
        const { learningAsset, isLocked, handleAssetRowClick, isReviewCollection, isLockedReflection } = this.props;
        const learningAssetDuration = LEARNING_ASSET_DURATIONS();
        const assetCompleteness = this._getCompleteness();
        let assetType = 'ACTIVITY';

        if (learningAsset && learningAsset.type) {
            assetType = learningAsset.type.toUpperCase();
        }

        if (learningAsset && learningAsset.typeLabel && learningAsset.typeLabel !== 'NO_LABEL') {
            assetType = learningAsset.typeLabel.toUpperCase();
        }
        const assetTypeIcon = this._getAssetTypeIcon(assetType);

        let overlayProps = {};
        let onClickHandler = () => {
            handleAssetRowClick(learningAsset);
        };

        if (isLocked && !isReviewCollection) {
            overlayProps = {
                overlayId: overlayImageIds.locked,
                dimension: {
                    h: 250,
                    w: 250
                }
            };
            onClickHandler = null;
        }

        const tooltip = (
            <Tooltip id={'tooltip'}>
                {LEARNING_ASSET_TYPE_OBJECT[assetType] ? LEARNING_ASSET_TYPE_OBJECT[assetType].label_hover : ''}
            </Tooltip>
        );

        const dropdownData = [
            {
                text: 'View Activity',
                fontAwesomeIcon: 'fa-eye',
                fontAwesomeIconWeight: 'fal',
                anchorTag: {
                    href: `${this.context.pathsWeb.clientUrl}/assetlink/${learningAsset._id}`,
                    newTab: true
                }
            },
            {
                text: 'Provide Feedback',
                fontAwesomeIcon: 'fa-comment',
                fontAwesomeIconWeight: 'fal',
                onClick: onClickHandler
            }
        ];

        return (
            <Row
                className={cns('asset-row', {
                    locked: isLocked,
                    unlocked: !isLocked,
                    lockedReflection: isLockedReflection
                })}
                onClick={onClickHandler}
            >
                <div
                    className={cns('asset-panel', {
                        'col-md-6 col-sm-6 col-8': !isReviewCollection,
                        'col-md-5 col-sm-5 col-7': isReviewCollection
                    })}
                >
                    <div className='d-flex gap-3'>
                        <Image
                            src={learningAsset.thumbnailImageUrl}
                            className={'asset-thumbnail'}
                            dimension={{ h: 250, w: 250 }}
                            overlay={overlayProps}
                            cloudinaryCrop={'fill'}
                            style={{ maxWidth: '80px', maxHeight: '80px' }}
                            quality={{ q: 100 }}
                        />
                        <div className='d-flex justify-content-start flex-column'>
                        <h4 className={'asset-name'}>{learningAsset.name || ''}</h4>
                        <p className={'asset-description'}>{get(learningAsset, 'subtitle', '')}</p>
                        </div>
                    </div>
                </div>
                <div className={'col-md-2 col-sm-2 col-4 icon-container completeness d-none d-sm-flex'}>
                    {!isLockedReflection && (
                        <i
                            className={cns(
                                'asset-completeness-icon fal fa-fw',
                                completionStatusIcon[assetCompleteness],
                                assetCompleteness
                            )}
                        />
                    )}
                    <span className={cns('asset-completeness', assetCompleteness)}>
                        {assetCompleteness === 'LOCKED' && !isLockedReflection ? '' : assetCompleteness}
                    </span>
                </div>
                <div className={'col-md-1 col-sm-1 col-4  icon-container type d-none d-md-flex'}>
                    <OverlayTrigger placement={'top'} transition={false} overlay={tooltip}>
                        <i className={cns('asset-type-icon fal fa-fw', assetTypeIcon, assetType)} />
                    </OverlayTrigger>
                </div>
                <div className={'col-md-2 col-sm-2 col-4 icon-container duration d-none d-sm-flex'}>
                    <i className={'asset-duration-icon fal fa-fw fa-clock duration-icon'} />
                    <h5 className={'asset-duration'}>
                        {get(learningAssetDuration[learningAsset.durationId], 'label', '').toLocaleUpperCase()}
                    </h5>
                </div>
                {isReviewCollection && (
                    <div
                        className={'col-1'}
                        onClick={(e) => {
                            e.stopPropagation();
                        }}
                    >
                        <VerbDropdownButton
                            fontAwesomeIcon={'fa-ellipsis-h'}
                            dropdownData={dropdownData}
                            buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                            popoverPlacement={'bottom'}
                        />
                    </div>
                )}
            </Row>
        );
    }
}

export default CollectionLearningAssetRow;
